module.exports = __webpack_public_path__ + "img/i-bdsm.1d3b41b0.svg";